(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/trixa.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/trixa.js');

'use strict';

const lazy = svs.components.lbUtils.lazy.lazy;
const Loader = svs.components.ReactLoader.Loader;
const GameKicks = lazy('/cl/lb-ui/react:game-kicks', () => svs.components.lbUi.gameKicks.GameKicks, {
  fallback: Loader
});
const Trixa = _ref => {
  let branding = _ref.branding,
    classNames = _ref.classNames;
  return React.createElement("div", {
    className: "".concat(classNames, " show-game")
  }, React.createElement(GameKicks, {
    branding: branding
  }));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.Trixa', Trixa);

 })(window);